import { Component as BaseComponent, h } from 'preact';
import { connect } from 'preact-redux';

class Component extends BaseComponent {
    constructor() {
        super();
        this.setState({
            isShuffling: false,
            shuffleDeck: null,
        });
    }

    render() {
        return (
            <tarot-reading-shuffle>
                {this.renderButton()}
            </tarot-reading-shuffle>
        );
    }

    renderButton = () => {
        if (this.state.isShuffling) {
            return (
                <button class='shuffle-button' onClick={this.stopShuffle}>Stop Shuffle</button>
            );
        }

        return (
            <button class='shuffle-button' onClick={this.startShuffle}>Shuffle Cards</button>
        );
    }

    stopShuffle = () => {
        window.clearInterval(this.state.shuffleDeck);
        this.setState({isShuffling: false});
        [].map.call(document.querySelectorAll('tarot-reading-deck-card'), (el) => {
            el.classList.remove('shuffle');
        });
        this.props.shuffleDeck();
    }

    startShuffle = () => {
        this.setState({
            isShuffling: true,
            shuffleDeck: window.setInterval(this.shuffle, 100),
        });
    }

    shuffle = () => {
        const max = this.props.spread.length + 1;
        const math_random = (Math.random() * (max - 1)) + 1;
        const random = Math.floor(math_random);
        const el = $('tarot-reading-deck-card:nth-of-type(' + random + ')');

        if (el) {
            el.addClass('shuffle').delay(500).queue((next) => {
                el.removeClass('shuffle');
                next();
            });
        }
    }
}

const mapStateToProps = (state) => ({
    spread: state.deck && state.deck.spread,
});

const mapDispatchToProps = (dispatch) => ({
    shuffleDeck: () => dispatch({ type: 'tarot-reading:shuffle-deck' }),
});

export default connect(mapStateToProps, mapDispatchToProps)(Component);



// WEBPACK FOOTER //
// ./app/components/tarot-readings/tarot-reading/shuffle.js